import React from 'react';
import { Content } from './Content';
import { CalculateReturnOfInvestmentsProvider } from '@/context/CalculatorReturnOfInvestment';

export function CalculatorReturnOfInvestments() {
	return (
		<CalculateReturnOfInvestmentsProvider>
			<Content />
		</CalculateReturnOfInvestmentsProvider>
	);
}
